{
	"accept_invite": {
		"description": "Set a password to complete your account activation.",
		"invalid_link_description": "Contact your administrator to request a new invitation.",
		"invalid_link_title": "This invitation link is invalid",
		"submit": "Activate account",
		"success": "Account activated: you are signed in.",
		"title": "Activate your account"
	},
	"aside": {
		"description": "Calls, applications and rankings of the university residences, in one place.",
		"title": "Unicasa console"
	},
	"back_to_login": "Return to sign in",
	"confirm_password": "Confirm password",
	"cooldown": "Resend in {{seconds}}s",
	"email_placeholder": "Enter your email address",
	"forgot_password": {
		"description": "Enter your account email address and we will send you a password reset link.",
		"email_sent_description": "Check your email and follow the instructions to reset your password.",
		"email_sent_title": "Email sent",
		"resend": "Resend",
		"submit": "Send reset link",
		"title": "Forgot password?"
	},
	"log_in": "Login",
	"login": {
		"description": "Enter your email below to login to your account",
		"forgot_password": "Forgot your password?",
		"locked_until": "Too many wrong passwords: account locked until {{time}}.",
		"remember": "Remember me for 7 days (facility managers only)",
		"sso_error": "Login failed. Please try again.",
		"title": "Login to your account"
	},
	"reset_password": {
		"description": "Choose a strong password to secure your account",
		"invalid_token": "This password reset link is invalid or has expired.",
		"request_new_link": "Request a new reset link",
		"submit": "Reset password",
		"title": "Set a new password"
	},
	"validation": {
		"email_invalid": "Please enter a valid email address.",
		"password_invalid": "Please enter a valid password.",
		"passwords_mismatch": "Passwords do not match."
	}
}
